import { Box, Paper, Typography, useTheme, Tooltip, Tabs, Tab } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { FaEye, FaRegCreditCard, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Can } from '../../../Components/Can';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { Loader } from '../../../Components/Loader';
import { ModalSelectOrderChoices } from '../../../Components/Modals/variants/select-order-choices/select-order-choices.component';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { Tag } from '../../../Components/Tag/tag.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { ListOrdersUseCase } from '../../../Usecase/Orders/list-orders-usecase';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { FormatMoney } from '../../../utils/formatMoney';
import { normalizeFinancialStatusTitle, normalizeSFinancialStatusColors } from '../../../utils/normalizeFinancialStatus';
import { labelsOrderProductionStage, normalizeOrderProductionStage } from '../../../utils/normalizeProductionStages';
import { ServiceOrderStageEnum } from '../../../Services/api/service-orders/service-order.interface';
import { useListOrders } from './orders-list.hook';
import { Flex } from '../../../Components/Flex/flex.component';
import { OrderFiltersDrawer } from '../../../Components/Drawer/variants/orders-filters/orders-filters-drawer.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { IoFilterOutline, IoAddOutline } from 'react-icons/io5';
import { IOrdersListPayload, OrderProductionStatusEnum, OrderStatusEnum } from '../../../Services/api/orders/orders.interface';
import { ReprocessOrderPaymentsUseCase } from '../../../Usecase/OrderPayments/reprocess-order-payments-usecase';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { CustomTabPanel } from '../../../Components/Tabs/CustomTabPanel/custom-tab-panel.component';
import { KanbanBoardOrders } from '../../../Components/KanbanBoardOrders/kanban-board-orders.component';
import { normalizeOrderStatusColors, normalizeOrderStatusTitle } from '../../../utils/normalizeOrderStatus';
import { PickingFlowUseCase } from '../../../Usecase/Orders/picking-flow.usecase';
import { UpdateOrdersUseCase } from '../../../Usecase/Orders/update-order-usecase';
import { ExportInPickingOrderUseCase } from '../../../Usecase/Orders/export-in-picking-order.usecase';
import { ShowOrdersUseCase } from '../../../Usecase/Orders/show-order-usecase';
import { CancelOrderUseCase } from '../../../Usecase/Orders/cancel-order-usecase';
import { ImportOrderUseCase } from '../../../Usecase/Orders/import-order-usecase';
import { ImportOrderDrawer } from '../../../Components/Drawer/variants/import-orders/import-orders-drawer.component';
import { color } from '@chakra-ui/react';
import { OrderStatusCell } from '../../../Components/OrderStatusCell';

interface IOrdersList {
    listProductUseCase: ListProductUseCase
    listOrdersUseCase: ListOrdersUseCase
    reprocessOrderPaymentsUseCase: ReprocessOrderPaymentsUseCase
    pickingFlowUseCase: PickingFlowUseCase
    UpdateOrdersUseCase: UpdateOrdersUseCase
    exportInPickingOrderUseCase: ExportInPickingOrderUseCase
    showOrdersUseCase: ShowOrdersUseCase
    cancelOrderUseCase: CancelOrderUseCase
    importOrderUseCase: ImportOrderUseCase
}

const OrdersList : FC<IOrdersList> = ({ listProductUseCase, listOrdersUseCase, reprocessOrderPaymentsUseCase, pickingFlowUseCase, UpdateOrdersUseCase, exportInPickingOrderUseCase, showOrdersUseCase, cancelOrderUseCase, importOrderUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { 
        listOrders, 
        list, 
        data, 
        handleShowDetails, 
        showDetails, 
        setShowDetails,  
        setShowModalChoices, 
        showModalChoices, 
        loading, 
        totalRegisters, 
        setShowFiltersModal, 
        showFiltersModal,
        currentFilters,
        setCurrentFilters,
        handleFilterSelect,
        handleReprocessPayment,
        orderToReprocess,
        setOrderToReprocess,
        handleChange,
        a11yProps,
        value,
        kanbanSchema,
        handleUpdateOrderStatus,
        handlePrintPickingList,
        handleCardClick,
        orderDetailsData,
        orderToCancel,
        setOrderToCancel,
        handleCancelOrder,
        hasCancelPermission,
        listCancelling,
        listOrdersCancelling,
        totalRegistersCancelling,
        handleImportOrder,
        showImportOrderModal,
        setShowImportOrderModal,
        currentFiltersCancelling,
        handlePageChangeOrders,
        handlePageChangeCancelling,
        handleSearch,
        handleSortModelChange,
        handleSortModelChangeCancelling
    } = useListOrders({
        listProductUseCase,
        listOrdersUseCase,
        reprocessOrderPaymentsUseCase,
        pickingFlowUseCase,
        UpdateOrdersUseCase,
        exportInPickingOrderUseCase,
        showOrdersUseCase,
        cancelOrderUseCase,
        importOrderUseCase
    })




    const columnsListing = useMemo(() => {
        const createColumns: any[] = [ 
          {
            field: 'nsOrderId',
            headerName: 'Pedido',
            width: 200,
            renderCell: (params: any) => <Box sx={{width: '100%', py: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{`#${params.value}`}</Typography></Box>
          },
          {
            field: 'store',
            headerName: 'Loja',
            flex:1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => <Box sx={{width: '100%', py: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{`${params?.value || 'Não informado'}`}</Typography></Box>
          },
          {
            field: 'createdAt',
            headerName: 'Data',
            width: 200,
            sortable: true,
            renderCell: (params: any) => <Box sx={{width: '100%', py: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{params.value}</Typography></Box>
          },
          {
            field: 'customer',
            headerName: 'Cliente',
            flex: 1,
            minWidth: 200,
            sortable: true,
            renderCell: (params: any) => <Box sx={{width: '100%', py: 1, px: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{`${params?.value?.name || 'Não informado'}`}</Typography></Box>
          },
          {
            field: 'totalValue',
            headerName: 'Total',
            width: 200,
            sortable: true,
            renderCell: (params: any) => <Box sx={{width: '100%', py: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{`${FormatMoney(Number(params?.value))}`}</Typography></Box>
          },
          {
            field: 'observations',
            headerName: 'Observações',
            headerAlign: 'center',
            flex: 1,
            minWidth: 200,
            renderCell: (params: any) => <Box sx={{width: '100%', py: 1, px: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%', textAlign: 'center'}}>{params?.value ? params?.value : '--'}</Typography></Box>
          },
          {
            field: 'status',
            headerName: 'Status',
            headerAlign: 'center',
            flex: 1,
            minWidth: 280,
            renderCell: (params: any) => (
              <OrderStatusCell 
                status={params.row.status}
                productionStatus={params.row.productionStatus}
                errorMessage={params.row.errorMessage}
              />
            )
          },
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "left",
            width: 120,
            renderCell: (params: any) => <Box sx={{width: '100%', display: 'flex', alignItems: 'center', py: 1}}><ButtonActionMenu options={[
              {
                title: 'Ver detalhes',
                onClick: () => navigate(`/financial-details/${params.row.id}`),
                icon: <FaEye />
              },
              {
                title: 'Reprocessar Pagamento',
                onClick: () => setOrderToReprocess(params.row.id),
                icon: <FaRegCreditCard />
              },
              // ...(hasCancelPermission ? [{
              //   title: 'Cancelar Pedido',
              //   onClick: () => setOrderToCancel(params.row.id),
              //   icon: <FaTrash />
              // }] : [])

   
              
            ]} /></Box>
          }
        ];
      
        return createColumns;
    }, []);

    const columnsCancelling = useMemo(() => {
      const createColumns: any[] = [ 
        {
          field: 'nsOrderId',
          headerName: 'Pedido',
          width: 200,
          renderCell: (params: any) => <Box sx={{width: '100%', py: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{`#${params.value}`}</Typography></Box>
        },
        {
          field: 'store',
          headerName: 'Loja',
          flex:1,
          headerAlign: 'center',
          align: 'center',
          renderCell: (params: any) => <Box sx={{width: '100%', py: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{`${params?.value || 'Não informado'}`}</Typography></Box>
        },
        {
          field: 'createdAt',
          headerName: 'Data',
          width: 200,
          sortable: true,
          renderCell: (params: any) => <Box sx={{width: '100%', py: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{params.value}</Typography></Box>
        },
        {
          field: 'customer',
          headerName: 'Cliente',
          flex: 1,
          minWidth: 200,
          sortable: true,
          renderCell: (params: any) => <Box sx={{width: '100%', py: 1, px: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{`${params?.value?.name || 'Não informado'}`}</Typography></Box>
        },
        {
          field: 'totalValue',
          headerName: 'Total',
          width: 200,
          sortable: true,
          renderCell: (params: any) => <Box sx={{width: '100%', py: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%'}}>{`${FormatMoney(Number(params?.value))}`}</Typography></Box>
        },
        {
          field: 'observations',
          headerName: 'Observações',
          headerAlign: 'center',
          flex: 1,
          minWidth: 200,
          renderCell: (params: any) => <Box sx={{width: '100%', py: 1, px: 1}}><Typography sx={{whiteSpace: 'normal', wordWrap: 'break-word', width: '100%', textAlign: 'center'}}>{params?.value ? params?.value : '--'}</Typography></Box>
        },
        {
          field: 'payment_status',
          headerName: 'Status',
          headerAlign: 'center',
          flex: 1,
          minWidth: 280,
          renderCell: (params: any) => <Box sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: 1,
            px: 1
          }}>
        
            {params?.row?.productionStatus === OrderProductionStatusEnum.PRODUCTION && (
              <Tag 
                title='Aguardando produção' 
                boxStyle={{ backgroundColor: 'rgba(110, 197, 5, 0.73)', width: '100%', padding: '12px', whiteSpace: 'nowrap', boxSizing: 'border-box' }} 
                titleStyle={{ color: '#FFFFFF', fontSize: '15px', width: '100%', textAlign: 'center', whiteSpace: 'nowrap', boxSizing: 'border-box' }} 
              />
            )}

           
            {!["DEAD"].includes(params.row.status) && params.row.status !== OrderStatusEnum.INVOICE_PROBLEM && params?.row?.productionStatus !== OrderProductionStatusEnum.PRODUCTION && (
              <Tag 
                title={normalizeOrderStatusTitle(params.row.status as OrderStatusEnum)} 
                boxStyle={{ 
                  backgroundColor: normalizeOrderStatusColors(params.row.status as OrderStatusEnum)?.bgColor, 
                  width: '100%', 
                  padding: '12px',
                  whiteSpace: 'nowrap',
                  boxSizing: 'border-box'
                }} 
                titleStyle={{ 
                  color: normalizeOrderStatusColors(params.row.status as OrderStatusEnum)?.textColor, 
                  fontSize: '15px', 
                  width: '100%', 
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  boxSizing: 'border-box'
                }} 
              />
            )}
              
          </Box>
        },
        {
          field: "actions",
          headerName: "Ações",
          headerAlign: "left",
          width: 120,
          renderCell: (params: any) => <Box sx={{width: '100%', display: 'flex', alignItems: 'center', py: 1}}><ButtonActionMenu options={[
            // {
            //   title: 'Ver detalhes',
            //   onClick: () => navigate(`/financial-details/${params.row.id}`),
            //   icon: <FaEye />
            // },
            // {
            //   title: 'Reprocessar Pagamento',
            //   onClick: () => setOrderToReprocess(params.row.id),
            //   icon: <FaRegCreditCard />
            // },
            ...(hasCancelPermission ? [{
              title: 'Cancelar Pedido',
              onClick: () => setOrderToCancel(params.row),
              icon: <FaTrash />
            }] : [])

 
            
          ]} /></Box>
        }
      ];
    
      return createColumns;
    }, []);
   

    return (
      <Can permissions={['menu:orders:manage']}>
        <ConfirmDialog title='Reprocessar Pagamento' onCancel={() => setOrderToReprocess('')} description='Você tem certeza?' open={!!orderToReprocess} onConfirm={() => handleReprocessPayment(orderToReprocess || '')}  /> 

        <ConfirmDialog title='Cancelar Pedido' onCancel={() => setOrderToCancel(undefined)} description='Você tem certeza?' open={!!orderToCancel} onConfirm={handleCancelOrder} input={{ label: 'Motivo', placeholder: 'Preencha o motivo', required: false }} /> 

        <BaseScreen>
          {loading && <Loader />}
          <Paper >
            {showModalChoices && <ModalSelectOrderChoices handleClose={() => setShowModalChoices(false)} />}
            
            <OrderFiltersDrawer 
              handleSelect={handleFilterSelect} 
              open={showFiltersModal} 
              title='Filtros' 
              onToggle={() => setShowFiltersModal(prev => !prev)} 
            />

            <ImportOrderDrawer 
              handleSelect={handleImportOrder} 
              open={showImportOrderModal} 
              title='Importar Pedido' 
              onToggle={() => setShowImportOrderModal(prev => !prev)} 
            />
          
            {/* {showDetails && <SaleDetailsModal  onClose={() => setShowDetails(undefined)} data={showDetails} type='sale' />} */}
              <BaseContentPage 
                  title='Pedidos'
                  breadcrumb={[{ title: 'Pedidos', link: "/orders-list"}, { title: 'Listagem'}]}
                  search
                  searchFunction={(data) => {
                    handleSearch({ ...currentFilters, searchBy: data.searchBy, page: data.page })
                  }}
                  Action={() => <>
                  <Flex gap={2} alignItems='center'justifyContent='flex-end'>
                    <Button LeftIcon={() => <IoAddOutline size={25} />} sx={{ width: '180px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => setShowImportOrderModal(true)}>Importar Pedido</Button>
                      <Button LeftIcon={() => <IoFilterOutline size={18} />} sx={{ width: '100px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => setShowFiltersModal(true)}>Filtros</Button>
                    </Flex>
                   
                  </>}
              >

                <Tabs value={value} onChange={handleChange}>
                      <Tab label="Lista" {...a11yProps(0)} />
                      <Tab label="Separação B2B" {...a11yProps(1)} />
                      <Tab label="Cancelamento" {...a11yProps(2)} />
                </Tabs>

                <CustomTabPanel value={value} index={0} >
                  {!!list?.length ? <Table data={list} columns={columnsListing} totalCount={totalRegisters} onPageChange={handlePageChangeOrders} onSortModelChange={handleSortModelChange} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1} >
                  <KanbanBoardOrders 
                    initialData={kanbanSchema} 
                    handleSelectProductToBill={() => {}} 
                    productsToBill={[]} 
                    setOmieOrderData={() => {}} 
                    canClick={true} 
                    canDrag={true} 
                    handleUpdateOrderStatus={handleUpdateOrderStatus}
                    onPrintPickingList={handlePrintPickingList}
                    onCardClick={handleCardClick}
                    orderDetailsData={orderDetailsData}
                  />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={2} >
                  {!!listCancelling?.length ? <Table data={listCancelling} columns={columnsCancelling} totalCount={totalRegistersCancelling} onPageChange={handlePageChangeCancelling} onSortModelChange={handleSortModelChangeCancelling} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </CustomTabPanel> 
                
              </BaseContentPage>
          </Paper>          
        </BaseScreen>
      </Can>
    )
}

export { OrdersList };
